import { render, staticRenderFns } from "./explanationWrapp3.vue?vue&type=template&id=6c1fe5b7&scoped=true&"
import script from "./explanationWrapp3.vue?vue&type=script&lang=js&"
export * from "./explanationWrapp3.vue?vue&type=script&lang=js&"
import style0 from "./explanationWrapp3.vue?vue&type=style&index=0&id=6c1fe5b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1fe5b7",
  null
  
)

export default component.exports